var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDownArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859497 1.59934C-0.0871423 2.57248 -0.0656591 4.12894 0.907478 5.07558L13.0988 16.9234C15.0456 18.8152 18.157 18.7715 20.0498 16.8258L31.9048 4.63889C32.8515 3.66575 32.83 2.10929 31.8568 1.16265C30.8836 0.215765 29.3272 0.237247 28.3805 1.21063L18.2339 11.6413C17.287 12.6144 15.7308 12.6359 14.7576 11.6892L4.33574 1.55136C3.3626 0.60472 1.80614 0.626204 0.859497 1.59934Z",
    fill: "rgba(239, 239, 239, 0.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDownArrow);
export default __webpack_public_path__ + "static/media/card-down-arrow.ce3ad8a9dfdda77a1431f2cf0d2335a2.svg";
export { ForwardRef as ReactComponent };